import { createEntitySlice } from "../firestoreModuleUtils/slice";
import { Scene } from "./records";

const slice = createEntitySlice<Scene>({ name: "roomScenes" });

export const reducer = slice.reducer;
export const actions = slice.actions;
